import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ListSkeleton } from "@/components/common/states";
import { Thread } from "@/components/inbox/thread";
import { q } from "@/data/queries";

export const Route = createFileRoute("/p/$project/inbox/$chatId")({
  loader: async ({ context, params }) => {
    const chat = await context.queryClient.ensureQueryData(q.chat(params.chatId));
    if (!chat) throw notFound();
    await Promise.all([
      context.queryClient.ensureQueryData(q.chatMessages(chat.id)),
      context.queryClient.ensureQueryData(q.account(chat.accountId)),
    ]);
    return { chat };
  },
  pendingComponent: ListSkeleton,
  component: ChatPage,
});

function ChatPage() {
  const { chat } = Route.useLoaderData();
  const { data: messages } = useSuspenseQuery(q.chatMessages(chat.id));
  const { data: account } = useSuspenseQuery(q.account(chat.accountId));
  return <Thread chat={chat} messages={messages} account={account} />;
}
